import PortalIdParser from 'PortalIdParser';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import _getDataPrivacySettings from 'forms-utils-lib/api/dataPrivacySettings/getDataPrivacySettings';
export const getDataPrivacySettings = ({
  earlyRequestKey
}) => {
  const portalId = PortalIdParser.get();
  return earlyRequestKey ? getFromEarlyRequest(earlyRequestKey, () => _getDataPrivacySettings({
    portalId
  })) : _getDataPrivacySettings({
    portalId
  });
};